import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FileDocument } from "../models/filedocument";
import { SearchDocuments } from "../models/search-documents";
import { SearcDocumentsPagedResponse } from "../models/search-documents-paged-response";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
  private baseUrl = "api/documents";
  private publicBaseUrl = "api/public/documents";

  constructor(private http: HttpClient) {}

  uploadDocument(administrativeUnitId: string, uploadData: FormData) {
    const headers = new HttpHeaders({
      "Content-Disposition": "multipart/form-data",
      Accept: "application/json, text/plain, */*",
    });

    return this.http.post<FileDocument[]>(
      `${this.baseUrl}/${administrativeUnitId}/upload`,
      uploadData,
      { headers }
    );
  }

  deleteDocument(docId: string) {
    return this.http.delete(`${this.baseUrl}/${docId}`);
  }

  publicUploadDocument(administrativeUnitId: string, uploadData: FormData) {
    const headers = new HttpHeaders({
      "Content-Disposition": "multipart/form-data",
      Accept: "application/json, text/plain, */*",
    });

    return this.http.post<FileDocument[]>(
      `${this.publicBaseUrl}/${administrativeUnitId}/upload`,
      uploadData,
      { headers }
    );
  }

  publicDeleteDocument(docId: string) {
    return this.http.delete(`${this.publicBaseUrl}/${docId}`);
  }

  getDocument(docId: string) {
    return this.http.get<string>(`${this.baseUrl}/${docId}`, {
      responseType: "text" as "json",
    });
  }

  search(request: SearchDocuments) {
    return this.http.post<SearcDocumentsPagedResponse>(
      `${this.baseUrl}/search`,
      request
    );
  }

  updateTags(documentId: string, tagIds: string[]): Observable<void> {
    var req = {
      tagIds: tagIds,
    };
    return this.http.put<void>(`${this.baseUrl}/${documentId}/tags`, req);
  }

  rename(documentId: string, title: string): Observable<void> {
    var req = {
      title: title,
    };
    return this.http.put<void>(`${this.baseUrl}/${documentId}/rename`, req);
  }
}
